
import Input from 'ui-kit/src/components/form/Input';
import Autocomplete from '@/mixins/Autocomplete';

export default {
    extends: Input,

    mixins: [
        Autocomplete,
    ],

    props: {
        searchTextFn: {
            type: [String, Function],
            default() {
                return this.$attrs.labelFn;
            },
        },
        topFilterFn: Function,
    },

    data() {
        return {
            separatorIndex: -1,
        };
    },

    methods: {
        getSearchText(item) {
            const text = (typeof this.searchTextFn === 'function') ? this.searchTextFn(item) : $.get(item, this.searchTextFn);

            return $.removeAccents(text).toLowerCase();
        },
        processFn(options) {
            if (!this.topFilterFn)
                return options;

            const [top, bottom] = _.partition(options, this.topFilterFn);

            if (top.length && bottom.length) {
                this.separatorIndex = top.length;
            } else {
                this.separatorIndex = -1;
            }

            return top.concat(bottom);
        },
    },
};
